module.exports = __webpack_public_path__ + "media/theme/icon__notice-d974ed22.png";